import { IAddArticleComment, IAddArticleCommentAction } from 'models/magazine/article/addarticlecomment';
import { IArticleComment } from 'models/magazine/article/articlecomment';
import { IStore } from 'redux/IStore';
import * as i18n from 'i18next';
import { actions as notifActions } from 'redux-notifications';
const { notifSend } = notifActions;

/** Action Types */
export const REQUEST_START: string = 'addarticlecomment/REQUEST_START';
export const REQUEST_FAILURE: string = 'addarticlecomment/REQUEST_FAILURE';
export const RESET_DATA: string = 'addarticlecomment/RESET_DATA';
export const ADD_COMMENT_SUCCESS: string = 'addarticlecomment/ADD_COMMENT_SUCCESS';

/** Initial State */
const initialState: IAddArticleComment = {
	isFetching: false,
	articleComment: null,
	newCommentAdded: false,
	error: false,
};

/** Reducer */
export function addArticleCommentReducer(state = initialState, action: IAddArticleCommentAction) {
	switch (action.type) {
		case REQUEST_START:
			return Object.assign({}, state, {
				isFetching: true,
				error: false,
			});

		case REQUEST_FAILURE:
			return Object.assign({}, state, {
				isFetching: false,
				message: action.payload.message,
				error: true,
			});

		case ADD_COMMENT_SUCCESS:
			return Object.assign({}, state, {
				articleComment: action.payload.articleComment,
				newCommentAdded: true,
			});

		case RESET_DATA:
			return Object.assign({}, state, {
				newCommentAdded: false,
				articleComment: null,
			});

		default:
			return state;
	}
}

/** Action Creator - create */
export function submitAddArticleComment(comment: IArticleComment) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Article/Comment',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
				body: JSON.stringify(comment),
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((newComment: IArticleComment) => {
						dispatch(addCommentSuccess(newComment));

						dispatch(
							notifSend({
								message: i18n.t('Notification_Success_Article_Comment_Added'),
								kind: 'success',
								dismissAfter: 3000,
							}),
						);
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function requestStart(): IAddArticleCommentAction {
	return {
		type: REQUEST_START,
	};
}

/** Action Creator */
export function requestFailure(message: any): IAddArticleCommentAction {
	return {
		type: REQUEST_FAILURE,
		payload: {
			message,
		},
	};
}

/** Action Creator */
export function addCommentSuccess(comment: IArticleComment): IAddArticleCommentAction {
	return {
		type: ADD_COMMENT_SUCCESS,
		payload: {
			articleComment: comment,
		},
	};
}

/** Action Creator */
export function resetData(): IAddArticleCommentAction {
	return {
		type: RESET_DATA,
	};
}
